import Routes from '../routes/routes'
import { buildGetApi } from './helpers'
import { buildTowns } from './converters/towns'

export default buildGetApi({
    route: Routes.apiGetFinePortalTowns,
    buildResult: buildTowns,
    mapParams: ({ countryId, brandId }) => ({ countryId, brandId }),
})
